import React from "react";
import "./ContactDetail.css";
import { Container, Grid, Typography, } from '@mui/material';

const ContactDetails = () => {
  return (
    <Container maxWidth="xl">
      <div className="contact-details" style={{ marginTop: "50px" }}>
        <Grid container sx={{ width: "100%" }} spacing={3}>
          <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
            {/* <Typography
              variant="h6"
              sx={{
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                lineHeight: "28.8px",
                fontSize: { xs: "16px", md: "22px", lg: "24px" },
                color: "#008BFF",
                textAlign: "left",
                ml: { md: 2 },
              }}
            >
              How can help you ?
            </Typography> */}
            <Typography
              variant="h6"
              sx={{
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                lineHeight: "28.8px",
                fontSize: { xs: "16px", md: "22px", lg: "24px" },
                color: "#008BFF",
                textAlign: "left",
                ml: { md: 2 },
              }}
            >
              Support for healthcare product orders and delivery
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                lineHeight: "57.6px",
                fontSize: { xs: "30px", md: "40px", lg: "48px" },
                color: "#253D4E",
                textAlign: "left",
                mt: 2,
              }}
            >
              Let us know how
              <br />
              we can help you
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                padding: "30px 0 15px",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Customer Station provides a single place for healthcare facilities and clinics to report issues, request product information, and coordinate deliveries for all medical products supplied by Life Line Products.
            </Typography>
            {/* <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
              tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </Typography> */}
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "0 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              01. Order Assistance
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Order status, tracking updates, incorrect items, missing items, damaged shipments, quantity issues.
            </Typography>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "60px 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              03.Delivery and Logistics
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Delivery schedule, urgent coordination, receiving requirements, carrier issues.
            </Typography>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "60px 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              05.Pricing and Account
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Quotes, contract pricing, invoicing, tax documents, payment verification.
            </Typography>

          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "0 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              02. Product Information
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Specifications, sizing, compatibility, manufacturer details, safety data sheets, instructions for use.
            </Typography>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "60px 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              04.Returns and Replacements
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Return authorization, replacement parts, product defects, warranty repair.
            </Typography>
            <Typography
              sx={{
                color: "#253D4E",
                padding: "60px 0 15px",
                textAlign: "left",
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                fontSize: "24px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
                "&:hover": {
                  color: "#008BFF",
                },
              }}
            >
              06.Account Access
            </Typography>
            <Typography
              sx={{
                color: "#7E7E7E",
                textAlign: "left",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 400,
                fontSize: "16px", // Default font size
                lineHeight: "24px", // Optional line height for better readability
              }}
            >
              Portal access, password reset, user permissions, billing contact update.
            </Typography>
          </Grid>

          <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2950.209776897475!2d-83.26688562387461!3d42.31672423783822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883b4a8900c92c6b%3A0x70d27a56a675fed5!2s700%20N%20York%20St%2C%20Dearborn%2C%20MI%2048128%2C%20USA!5e0!3m2!1sen!2sin!4v1757931855595!5m2!1sen!2sin"
              height="350"
              style={{ border: "0", width: "100%", marginTop: "60px" }}
              allowfullscreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default ContactDetails;
